import axios from 'axios';
import { CardDataCommand, CardDataStatusItem, CardMemberDataItem, UploadMyImageResponse } from './models/cardData';



export async function getCardDataStatusApi(secCode : string): Promise<CardDataStatusItem> {
    const baseUrl = process.env.REACT_APP_API_URL;
    const endpoint = `/api/v1/card-data/code/${secCode}/status`;
    const result = await axios.get(baseUrl + endpoint, { timeout: 60000 });
    return result.data as CardDataStatusItem;
}

export async function getCardDataMemberApi(secCode : string, pin: string): Promise<CardMemberDataItem> {
    const baseUrl = process.env.REACT_APP_API_URL;
    const endpoint = `/api/v1/card-data/code/${secCode}/pin/${pin}`;
    const result = await axios.get(baseUrl + endpoint, { timeout: 60000 });
    return result.data as CardMemberDataItem;
}

export async function updateCardDataMemberApi(secCode: string, pin:string,  cardDataCommand: CardDataCommand): Promise<void> {
    const baseUrl = process.env.REACT_APP_API_URL;
    const endpoint = `/api/v1/card-data/code/${secCode}/pin/${pin}`;
    await axios.put(baseUrl + endpoint, cardDataCommand, { timeout: 60000});
}

export async function uploadMyImageApi(cardDataCommand: UploadMyImageResponse): Promise<void> {
    const baseUrl = process.env.REACT_APP_API_URL;
    const endpoint = `/api/v1/card-data/upload-my-image`;
    await axios.post(baseUrl + endpoint, cardDataCommand, { timeout: 60000});
}


